//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { map } from "lodash";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
//  -- Constants ----------------------
import { useEffect } from 'react';
import { useAllBook, useBookOrder, useBooksCover } from "store/books/selectors";
import COLOR from "utils/constants/color";
import { storyData } from "store/constants";
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Image = styled.img`
  height: 100px;
  width: 80px;
`;

const Text = styled.div`
  font-size: 9px;
  color: white;
  white-space: pre-line;
  line-height: 13px;
`;

const TextContainer = styled.div`
  border-top: 1px solid ${COLOR.black800};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  min-height: 57px;
  width: 80px;
  padding:2px;
  background-color: #171e2d;
`;

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  cursor: pointer;
  height: auto;
  outline: none;
  transition: all 300ms ease;
  width: 100%;
 
  

`;

const ListItemCovers = styled.li`
  margin-top: 32px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom:10px;

  @media only screen and (max-width: 500px){
    margin-left: 0px;
  }
  
  box-shadow: ${(p) =>
        p.active ? p.preActive ? "-3px 2px 8px 0px #9d0001, 3px 1px 5px #9d0000;" : " -3px 2px 8px 0px #00989d, 3px 1px 5px #00989d;" : ""};
`;
const List = styled.ul`
  height: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style-type: none;
  justify-content: center;
  margin-top:24px;
  display: flex;
  flex-direction: column;
`;
const BookSection = styled.div`
    border: 2px solid #e9e9e9;
    box-shadow: ${(p) => p.active ? p.preActive ? "-3px 2px 8px 0px #9d0001, 3px 1px 5px #9d0000;" : " -3px 2px 8px 0px #00989d, 3px 1px 5px #00989d;" : ""};
    margin-bottom: 26px;
    width: 100%;
    position: relative;
    padding-left: 16px;
    padding-right: 16px;
    width: fit-content;
    margin-right: 16px;
    padding-bottom: 16px;
    
`;
const SectionTitle = styled.div`
    font-size: 14px;
    color: #ffffff;
    background: ${p => p.bgColor ? p.bgColor : '#00c4cc'};
    padding: 4px 8px;
    border-radius: 6px !important;
    cursor: pointer;
    position: absolute;
    top: -10px;
    left: -6px;
    width: 250px;
    z-index: 99;
`;

const SelectableBookByGroup = ({ books_group, onSelect, disabled , org_book_permissions=[],from="" }) => {
    const [selected_group, set_selected_group] = useState([])
    const bookOrder = useBookOrder()
    const booksCover = useBooksCover()
    const orderedBook = useMemo(() => {
        if(from === "class"){
           return bookOrder.map(k => {
            if (Array.isArray(org_book_permissions) && (org_book_permissions.length > 0) && !org_book_permissions.includes(k.key)) return null;
            return ({
                ...k,
                books: [...(k.order.map(bk => booksCover.find(b => b.id == bk)).filter(Boolean)),storyData]
            })
        }).filter(Boolean)
        }
        return bookOrder.map(k => {
            if (Array.isArray(org_book_permissions) && (org_book_permissions.length > 0) && !org_book_permissions.includes(k.key)) return null;
            return ({
                ...k,
                books: k.order.map(bk => booksCover.find(b => b.id == bk)).filter(Boolean)
            })
        }).filter(Boolean)
    }, [booksCover, bookOrder, org_book_permissions])
    useEffect(() => {
        if(Array.isArray(books_group))
        set_selected_group(books_group)
    }, [books_group])

    const handleSelectArea = (key) => {
        let value = selected_group;
        if (selected_group.includes(key)) {
            value = selected_group.filter(k => k != key)
        } else {
            value = [...selected_group, key]
        }
        set_selected_group(value)
        onSelect(value)
    }


    const RenderItem = React.useCallback(() => {
        return map(orderedBook, bk => {
            const is_selected = Boolean(selected_group.includes(bk.key))
            return (
                <div>
                    <BookSection key={bk.title} active={is_selected}
                        onClick={(e) => {
                            if (disabled) return;
                            e.preventDefault();
                            handleSelectArea(bk.key);
                        }}>
                        {bk.title ? <SectionTitle bgColor={bk.color} >{bk.title}</SectionTitle> : null}
                        <List>
                            <div style={{ display: 'flex', flexDirection: 'row' }} className="allCreateBook">
                                {map(bk.books, book => {
                                    if (!book || !book.id) return null;
                                    return (
                                        <ListItemCovers key={book.id} active={is_selected}>
                                            <Wrapper>
                                                <div className="card-resource">
                                                    <a >
                                                        <div className="card-resource-overlay" style={{ opacity: is_selected ? 0.5 : 0 }}></div>
                                                        <Image
                                                            className="card-resource-image"
                                                            src={book.img}
                                                            alt={book.description}
                                                        />
                                                        <TextContainer>
                                                            <Text>{book.description}</Text>
                                                        </TextContainer>
                                                    </a>
                                                </div>
                                            </Wrapper>
                                        </ListItemCovers>
                                    )
                                })}
                            </div>
                        </List>
                    </BookSection>
                </div>
            )
        })
    }, [orderedBook,selected_group])

    return (
        <List>
            <RenderItem />
        </List>
    );
};


export default SelectableBookByGroup;
